import React from "react";
import { motion } from "framer-motion";

// True during prerender snapshot and during client hydration of prerendered
// HTML. In that window we render plain DOM elements (no framer-motion) so the
// server markup exactly matches the client's first render — eliminating
// hydration mismatches caused by framer-motion applying styles via effects.
const isStatic = () => typeof window !== "undefined" && window.__WP_STATIC__ === true;

const ANIM_PROPS = [
  "initial", "animate", "exit", "variants", "transition", "custom",
  "whileInView", "whileHover", "whileTap", "whileFocus", "whileDrag",
  "viewport", "layout", "layoutId", "drag",
];

const make = (tag) =>
  React.forwardRef((props, ref) => {
    if (isStatic()) {
      const rest = { ...props };
      ANIM_PROPS.forEach((k) => delete rest[k]);
      return React.createElement(tag, { ...rest, ref });
    }
    return React.createElement(motion[tag], { ...props, ref });
  });

export const M = {
  div: make("div"),
  h1: make("h1"),
  h2: make("h2"),
  p: make("p"),
  span: make("span"),
  section: make("section"),
  li: make("li"),
  a: make("a"),
};

export default M;
